// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__2eDC9","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__25ZPN"};